import React from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
} from '@material-ui/core';
import { get, isEmpty, uniqueId } from 'lodash';
import SahamDrawer from 'components/SahamDrawer';
import messages from 'containers/CourtManagerLegalProceedings/JudgementAdd/Drawers/messages';
import civilPartyMessages from 'containers/LawyerLegalProceedingsPage/judgementAdd/CivilParty/messages';
import { translate } from 'containers/services/translate';
import { CivilParty } from 'containers/LawyerLegalProceedingsPage/judgementAdd/CivilParty/constants';
import civilPartymessages from 'containers/LawyerLegalProceedingsPage/judgementAdd/CivilParty/messages';
import { CivilPartyWrapper } from 'containers/CourtManagerLegalProceedings/JudgementAdd/Drawers/styled-components';
import { formatFieldToSave } from 'containers/CourtManagerLegalProceedings/JudgementAdd/Drawers/utils';
import { FIELDS_TO_UPDATE } from 'containers/CourtManagerLegalProceedings/JudgementAdd/Drawers/constants';
import { isChecked } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/utils';
import { filterVictim } from 'containers/CourtManagerLegalProceedings/utils';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import { EMPTY_SUPPORT_DOC } from 'containers/LawyerRecapPage/constants';
import { CIVIL_DOC_ID } from 'containers/CourtManagerLegalProceedings/JudgementAdd/Drawers/constants';
import { DOCUMENT_TYPES } from 'constants/global';
import UploadDocumentBloc from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/UploadDocumentBloc';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { getVictimFromSagisInfo } from 'containers/PreOpeningPage/utils';
import { CorporealDocument } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import Document from 'components/Document';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { handleOpenDocument } from 'services/utils';
import { VictimType } from 'typings/globalTypes';
export interface CivilPartyDrawerProps {
  intl: IntlShape;
  open: boolean;
  handleToggleDrawer: Function;
  civilDocuments: CivilParty[];
  index: number;
  setJudgementAdd: Function;
  victims: VictimType[];
  civilDocumentsVictims: Set<number>;
  setCivilDocumentsVictims: Function;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocuments: Function;
  document: {};
  setDocument: Function;
  setDocumentId: Function;
  documentId: any;
  sagisVictimInfo: any;
  requestGetDocByDocumentumId: Function;
}

const CivilPartyDrawer: React.FC<CivilPartyDrawerProps> = ({
  index,
  ...props
}): JSX.Element => {
  const handleSetVictims = (
    event: React.ChangeEvent<{ value: string; checked: boolean }>,
  ) => {
    const civilDocumentsVictims = new Set([...props.civilDocumentsVictims]);
    const id = Number(event.target.value);

    if (event.target.checked) {
      civilDocumentsVictims.add(id);
    } else {
      civilDocumentsVictims.delete(id);
    }

    props.setCivilDocumentsVictims(civilDocumentsVictims);
  };

  const setUpdateCivilDocument = (document: CorporealDocument) => {
    if (String(props.documentId) === CIVIL_DOC_ID) {
      props.setDocument({
        name: document.name,
        url: document.url,
        type: document.type,
        id: get(props.document, 'id'),
      });
      props.resetUploadedDocuments();
    }
  };

  const handleSaveDetails = () => {
    if (!isEmpty(get(props.document, 'url'))) {
      const updatedCivilDocuments = formatFieldToSave(
        [{ ...props.document }] as any,
        props.victims,
        props.civilDocumentsVictims,
        index,
      );
      props.setJudgementAdd(
        FIELDS_TO_UPDATE.CIVIL_DOCUMENTS,
        updatedCivilDocuments,
      );
    } else {
      const updatedCivilDocuments = formatFieldToSave(
        [...props.civilDocuments],
        props.victims,
        props.civilDocumentsVictims,
        index,
      );
      props.setJudgementAdd(
        FIELDS_TO_UPDATE.CIVIL_DOCUMENTS,
        updatedCivilDocuments,
      );
    }

    props.handleToggleDrawer();
  };
  return (
    <SahamDrawer
      open={props.open}
      handleToggleDrawer={props.handleToggleDrawer}
      title={translate(civilPartyMessages.civilPartyBlocTitle, props)}
      confirmButtonTitle={translate(messages.save, props)}
      handleValidateDrawer={handleSaveDetails}
      isSaveButtonDisabled={props.civilDocumentsVictims.size === 0}
    >
      <CivilPartyWrapper>
        {!isEmpty(props.victims) && (
          <FormControl className="victims-wrapper">
            <FormLabel className="victims-title">
              {translate(civilPartymessages.victimTitle, props)}
            </FormLabel>
            {filterVictim(props.victims).map(
              (victim: { id: unknown; firstName: any; lastName: any }) => (
                <FormGroup key={uniqueId(`edit-selected-victim`)}>
                  <FormControlLabel
                    className="checkbox-wrapper"
                    value={props.civilDocumentsVictims}
                    control={
                      <Checkbox
                        defaultChecked={isChecked(
                          victim.id as number,
                          props.civilDocumentsVictims,
                        )}
                        color="primary"
                        onChange={handleSetVictims}
                        value={victim.id}
                        className="checkbox"
                      />
                    }
                    label={
                      featureService.hasFeature(FEATURES.MIGRATION_CLAIM_INFO)
                        ? `${get(
                            getVictimFromSagisInfo(
                              get(victim, 'victimKey'),
                              props.sagisVictimInfo,
                            ),
                            'victimFirstName',
                            '',
                          )} ${get(
                            getVictimFromSagisInfo(
                              get(victim, 'victimKey'),
                              props.sagisVictimInfo,
                            ),
                            'victimLastName',
                            '',
                          )}`
                        : `${victim.firstName} ${victim.lastName}`
                    }
                  />
                </FormGroup>
              ),
            )}
          </FormControl>
        )}
        <div style={{ marginTop: '10px' }}>
          {props.civilDocuments.map(civilParty => {
            return (
              <section>
                <div>{translate(messages.documents, props)}</div>
                <Document
                  name={civilParty.name}
                  type={civilParty.type}
                  icon={
                    <VisibilityIcon
                      className="consult"
                      onClick={handleOpenDocument(
                        civilParty as any,
                        props.requestGetDocByDocumentumId,
                      )}
                    />
                  }
                />
              </section>
            );
          })}
        </div>
      </CivilPartyWrapper>

      <section style={{ padding: 12 }}>
        <UploadDocumentBloc
          document={props.document as any}
          setDocument={setUpdateCivilDocument}
          index={1}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          setDocumentId={props.setDocumentId}
          docType={DOCUMENT_TYPES.CIVIL}
          docId={CIVIL_DOC_ID}
          deleteDoc={() => {
            props.setDocument({
              ...EMPTY_SUPPORT_DOC,
              id: get(props.document, 'id'),
            });
          }}
        />
      </section>
    </SahamDrawer>
  );
};

export default injectIntl(CivilPartyDrawer);
